import { navItems } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.2fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">韩剧TV</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              本页用于整理韩剧TV的最新地址动态、官网地址 2025 说明、打不开的解决办法、新域名辨别与永久入口等信息，方便你在地址更换时快速找回正确入口，避免走丢。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-background-400">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-calendar-line text-xs"></i>
              </span>
              内容更新至 2025-10-06
            </p>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">快速导航</h2>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">安全提示</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-shield-line text-sm"></i>
                </span>
                不在来源不明的页面输入账号与支付信息
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-shield-line text-sm"></i>
                </span>
                遇到频繁跳转或强制下载请立即退出
              </li>
              <li className="flex items-start gap-2">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-400">
                  <i className="ri-shield-line text-sm"></i>
                </span>
                收藏本页作为固定入口，长期回访确认
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>本页仅用于整理公开的地址与访问指引信息，具体地址以官方公告为准。</p>
          <p>韩剧TV 最新地址与访问指南</p>
        </div>
      </div>
    </footer>
  );
}